<template>
    <div class="navbar_wrapper">
        <aside class="navbar">
            <div class="navbar_container">
                <div class="navbar_divider">
                    <ul class="nav_tab">
                        <li
                            v-for="module in modules"
                            :key="module.id"
                            class="nav_item activity_list"
                            :class="{
                                is_selected: getIsActiveModule(module),
                            }"
                            @click="handleModuleClick(module.type)"
                        >
                            <ActivityIcon
                                :icon="module.type"
                                :bg-color="getIsActiveModule(module) ? 'white' : 'gray'"
                            />
                            <span>{{ module.guide?.txt_type }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </aside>
    </div>
</template>

<script setup lang="ts">
    import { PropType } from 'vue';
    import { Module } from '@/app/api/models/module';
    import ActivityIcon from '@/teacher/components/ActivityIcon.vue';
    import { ModuleTypeEnum } from '@/enums/ModuleTypeEnum';

    const props = defineProps({
        modules: {
            type: Array as PropType<Module[]>,
            required: true,
        },
        activeModuleType: {
            type: Number as PropType<ModuleTypeEnum>,
            default: undefined,
        },
    });

    const emit = defineEmits<{
        (e: 'select-module', moduleType: ModuleTypeEnum): void;
    }>();

    /**
     * 활성 모듈인지 확인
     */
    function getIsActiveModule(module: Module) {
        if (props.activeModuleType !== undefined) {
            return props.activeModuleType === module.type;
        }
        return false;
    }

    /**
     * 모듈 클릭 핸들러
     */
    function handleModuleClick(moduleType: ModuleTypeEnum) {
        emit('select-module', moduleType);
    }
</script>
